import { useMemo } from 'react';
import { useConfig } from '@browsing/config';
import { isPlusEnabled } from '../utils';
export var usePlusFeature = function () {
    var config = useConfig();
    return useMemo(function () {
        var isEnabled = isPlusEnabled(config);
        return { isEnabled: isEnabled };
    }, [config]);
};
